import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { RadioGroup, Field, ControlGroup } from "@conserveit/blocks";
import { connect } from "react-redux";
import DynamicFormComponent from "./DynamicFormComponent";

@connect(
  (state) => ({
    isFormDisabled: state.reportGenerator.isFormDisabled,
  }),
  null,
  null,
  { forwardRef: true }
)
export default class SortByRadio extends DynamicFormComponent {
  static propTypes = {
    isFormDisabled: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.BY_KEY = "key";
    this.BY_PRIORITY = "priority";
    this.state = { sortMethod: this.BY_PRIORITY };
  }

  handleSortByChange = (value) => {
    this.setState({ sortMethod: value });
  };

  validate = () => true;

  getSelectedValues = () => {
    return { sortBy: this.state.sortMethod };
  };

  render() {
    return (
      <Field label="Sort By" name="reportSortBy">
        {({ name }) => (
          <ControlGroup vertical>
            <RadioGroup
              name={name}
              value={this.state.sortMethod}
              onChange={this.handleSortByChange}
              disabled={this.props.isFormDisabled}
              options={[
                { value: this.BY_PRIORITY, label: "Priority" },
                { value: this.BY_KEY, label: "Issue Key" },
              ]}
            />
          </ControlGroup>
        )}
      </Field>
    );
  }
}
